const hotels = {
  back: "Arrière", // translated
  rooms: "Pièces", // translated
  viewPictures: "Voir les photos", // translated
  showMore: "montre plus", // translated
  bookingInformation: "Informations de réservation", // translated
  importantInformation: "Informations importantes", // translated
  cancellationPolicy: "Politique d'annulation", // translated
  from: "Depuis", // translated
  to: "pour", // translated
  cancellationIs: "l'annulation est", // translated
  free: "libre", // translated
  chargeableWithFeeOf: "moyennant une redevance de", // translated
  prebook: "Pré-réservation", // translated
  guests: "Invités", // translated
  payment: "Paiement", // translated
  byClicking: "En cliquant", // translated
  next: "Suivant", // translated
  youAreAgreeingToOur: "vous acceptez notre", // translated
  termsAndConditions: "Termes et conditions", // translated
  previous: "Précédent", // translated
  cancel: "Annuler", // translated
  mealPlan: "Plan de repas", // translated
  roomType: "Type de chambre", // translated
  description: "La description", // translated
  readLess: "Lire moins", // translated
  readMore: "Lire la suite", // translated
  facilities: "Installations", // translated
  viewLess: "Afficher moins", // translated
  viewMore: "Voir plus", // translated
  less: "moins", // translated
  more: "Suite", // translated
  notAvailable_short: "N / A", // translated
  backToHotelList: "Retour à la liste des hôtels", // translated
  viewOnMap: "Voir sur la carte", // translated
  sleeps: "Dort", // translated
  adults: "Adultes", // translated
  yearsOld: "ans", // translated
  type: "Taper", // translated
  bedding: "Literie", // translated
  selectRoom: "Sélectionnez la chambre", // translated
  city: "Ville", // translated
  checkIn: "Enregistrement", // translated
  checkOut: "Vérifier", // translated
  date: "Date", // translated
  persons: "Personnes", // translated
  stillOnTrialQuestionToUpgrade: "Oups! Il semble que vous soyez toujours sur un abonnement d'essai. Vous devez être un membre confirmé pour effectuer des réservations. Souhaitez-vous mettre à niveau maintenant ?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Oups! Il semble que vous n'êtes pas encore abonné. Vous devez être un membre confirmé pour effectuer des réservations. Souhaitez-vous mettre à niveau maintenant ?", // translated
  completeProfile: "Veuillez d'abord compléter votre profil d'utilisateur", // translated
  upgrade: "Améliorer", // translated
  close: "proche", // translated
  viewDetails: "Voir les détails", // translated
  name: "Nom", // translated
  rating: "Évaluation", // translated
  budget: "Budget", // translated
  orderBy: "Commandé par", // translated
  priceLowestFirst: "Prix: les plus bas en premier)", // translated
  priceHighestFirst: "Prix: le plus élevé en premier)", // translated
  ratingLowestFirst: "Note (la plus basse en premier)", // translated
  ratingHighestFirst: "Classement (le plus élevé en premier)", // translated
  starRatingAndPrice: "Classement par étoiles et prix", // translated
  select: "Sélectionner", // translated
  reset: "Réinitialiser", // translated
  apply: "Appliquer", // translated
  filterBy: "Filtrer par", // translated
  myProfile: "Mon profil", // translated
  login: "Connexion", // translated
  roomOnly: "Chambre seulement", // translated
  bedAndBreakfast: "lit et petit-déjeuner", // translated
  halfBoard: "La moitié du tableau", // translated
  fullBoard: "Pension complète", // translated
  allInclusive: "Tout inclus", // translated
  filter: "Filtre", // translated
  mapView: "Vue de la carte", // translated
  results: "résultats", // translated
  listView: "Affichage de liste", // translated
  newSearch: "Nouvelle recherche", // translated
  editSearch: "Modifier la recherche", // translated
  all: "Tout", // translated
  multiple: "Plusieurs", // translated
  editProfile: "Editer le profil", // translated
  backToHotelsList: "Retour à la liste des hôtels", // translated
  roomName: "Nom de la salle", // translated
  mealType: "Type de repas", // translated
  freeCancellation: "Annulation gratuite", // translated
  yes: "Oui", // translated
  no: "Non", // translated
  filters: "Filtres", // translated
  cancellationNonRefundable: "L'annulation n'est pas remboursable", // translated
  biggestSavingsFirst: "Les plus grosses économies d’abord", // translated
  hotels: "Hôtels", // translated
  hotel: "Hôtel", // translated
  hotelRating: "Évaluation de l'hôtel", // translated
  off: "Désactivé", // translated
  accommodation: "Hébergement", // translated
  selectRooms: "Sélectionnez les chambres", // translated
  dates: "Rendez-vous", // translated
  performNewSearch: "Effectuer une nouvelle recherche", // translated
  any: "N'importe lequel", // translated
};


export default hotels;
